export enum MobileBridgeEvent {
  APP_READY = 'gw.app.ready',
  AUTH_TOKEN_UPDATE = 'gw.auth.token.update',
  AUTH_USER_LOGOUT = 'gw.auth.user.logout',
  AUTH_USER_UPDATE = 'gw.auth.user.update',

  NOTIFICATION = 'gw.notification',

  LOGO_CLICK = 'gw.ui.logo.click',
}
